import React from 'react';
import MelilloSensorAnalysis, { RequiredFields as MelilloSensorAnalysisRequiredFields } from './Melillo/SensorAnalysis';
import MelilloHemisphericAnalysis, {
	RequiredFields as MelilloHemisphericAnalysisRequiredFields,
	ValidationFunc as MelilloHemisphericAnalysisValidationFunc
} from './Melillo/HemisphericAnalysis';
import MelilloFollowUp, { RequiredFields as MelilloFollowUpRequiredFields } from './Melillo/FollowUp';
import MelilloDevelopmentalHistory, { RequiredFields as MelilloDevelopmentalHistoryRequiredFields } from './Melillo/DevelopmentalHistory';
import KindyRooDevelopmentalHistory, { RequiredFields as KindyRooDevelopmentalHistoryRequiredFields } from './KindyRoo/DevelopmentalHistory';
import KindyRooHemisphericAnalysis, {
	RequiredFields as KindyRooHemisphericAnalysisRequiredFields,
	ValidationFunc as KindyRooHemisphericAnalysisValidationFunc
} from './KindyRoo/HemisphericAnalysis';
import KindyRooBGQuestionnaire, { RequiredFields as KindyRooBGQuestionnaireRequiredFields } from './KindyRooBG/Questionnaire';
import KindyRooAUMedicalInformation, {
	RequiredFields as KindyRooAUMedicalInformationRequiredFields,
	ValidationFunc as KindyRooAUMedicalInformationValidationFunc
} from './KindyRooAU/MedicalInformation';
import ArtKMedicalInformation, {
	RequiredFields as ArtKMedicalInformationRequiredFields,
	ValidationFunc as ArtKMedicalInformationValidationFunc
} from './ArtK/MedicalInformation';

const Components = {
	MelilloSensorAnalysis: {
		component: MelilloSensorAnalysis,
		requiredFields: MelilloSensorAnalysisRequiredFields
	},
	MelilloHemisphericAnalysis: {
		component: MelilloHemisphericAnalysis,
		requiredFields: MelilloHemisphericAnalysisRequiredFields,
		validationFunc: MelilloHemisphericAnalysisValidationFunc
	},
	MelilloFollowUp: { component: MelilloFollowUp, requiredFields: MelilloFollowUpRequiredFields },
	MelilloDevelopmentalHistory: { component: MelilloDevelopmentalHistory, requiredFields: MelilloDevelopmentalHistoryRequiredFields },

	KindyRooDevelopmentalHistory: { component: KindyRooDevelopmentalHistory, requiredFields: KindyRooDevelopmentalHistoryRequiredFields },
	KindyRooHemisphericAnalysis: {
		component: KindyRooHemisphericAnalysis,
		requiredFields: KindyRooHemisphericAnalysisRequiredFields,
		validationFunc: KindyRooHemisphericAnalysisValidationFunc
	},
	KindyRooBGQuestionnaire: { component: KindyRooBGQuestionnaire, requiredFields: KindyRooBGQuestionnaireRequiredFields },
	KindyRooAUMedicalInformation: {
		component: KindyRooAUMedicalInformation,
		requiredFields: KindyRooAUMedicalInformationRequiredFields,
		validationFunc: KindyRooAUMedicalInformationValidationFunc
	},
	ArtKMedicalInformation: {
		component: ArtKMedicalInformation,
		requiredFields: ArtKMedicalInformationRequiredFields,
		validationFunc: ArtKMedicalInformationValidationFunc
	}
};

export default (form, options, currentFormValues, changeFormValue) => {		// options: { showResults: true }
	// component does exist
	if (typeof Components[form.name] !== 'undefined') {
		const { component, requiredFields, validationFunc } = Components[form.name];
		return {
			component: React.createElement(component, {
				resourcesNamespace: `form.${form.name}.resources`,
				isReadOnly: form.status === 'Final',
				currentFormValues,	// current redux-form field values from state
				changeFormValue,	// updates redux-form field value in state
				...options
			}),
			requiredFields,
			validationFunc
		};
	}
	// component doesn't exist yet
	return {
		component: React.createElement(
			() => <div>The form {form.name} has not been created yet.</div>
		),
		requiredFields: [],
		validationFunc: null
	};
};